import styled from 'foundations-theming/utils';
import { Fragment, useEffect, useRef } from 'react';
import { View } from 'foundations-components/components/View';
import { CategoryHeader } from './category-header/CategoryHeader';
import { ChildFeatureRow } from './feature-table-row/ChildFeatureRow';
import { ParentFeatureRow } from './feature-table-row/ParentFeatureRow';
import { useFeatureTableSessionCache } from './FeatureTableSessionCacheProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTable = styled.table.withConfig({
  displayName: "CategorizedFeatures__StyledTable"
})(["border-collapse:collapse;width:100%;& > tbody > tr > td{padding:", ";vertical-align:middle;}& > tbody > tr > td:first-child{width:35%;}& > thead > tr > th{vertical-align:bottom;}& > thead > tr > th > div{min-height:150px;}& > thead > tr > th:first-child{text-align:left;padding-bottom:", ";}& > tbody > tr > td:not(:first-child){text-align:center;width:", ";}& > tbody > tr > td{border-bottom:1px solid ", ";}& > tbody > tr > td:not(:last-child){border-left:0px;border-right:1px solid ", ";}"], ({
  theme
}) => theme.space[500], ({
  theme
}) => theme.space[500], ({
  columnCount
}) => `${(100 - 35) / columnCount}%`, ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.color['border-core-default']);
export const CategorizedFeatures = ({
  category,
  focusedCategory,
  onIntersectionChange,
  tableHeaderConfig
}) => {
  const {
    productApiNames,
    skuCategoryName
  } = useFeatureTableSessionCache();
  const CategorizedFeaturesRef = useRef(null);
  const onIntersectionChangeRef = useRef(onIntersectionChange);
  useEffect(() => {
    onIntersectionChangeRef.current = onIntersectionChange;
  }, [onIntersectionChange]);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const [entry] = entries;
      onIntersectionChangeRef.current(entry.isIntersecting);
    });
    if (CategorizedFeaturesRef.current) {
      observer.observe(CategorizedFeaturesRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return /*#__PURE__*/_jsxs(StyledTable, {
    columnCount: productApiNames.length,
    ref: CategorizedFeaturesRef,
    children: [/*#__PURE__*/_jsx(CategoryHeader, {
      title: category.category.categoryName,
      tableHeaderConfig: tableHeaderConfig,
      focusedCategory: focusedCategory
    }), /*#__PURE__*/_jsx(View, {
      as: "tbody",
      children: category.features.map(feature => /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(ParentFeatureRow, {
          feature: feature,
          productApiNames: productApiNames,
          trackingProperties: {
            featureName: feature.displayName,
            skuCategoryName,
            featureCategoryName: category.category.categoryName,
            isParentFeature: true
          }
        }), feature.childrenFeatures.map(childFeature => /*#__PURE__*/_jsx(ChildFeatureRow, {
          isParentFeatureInBeta: feature.isBeta,
          childFeature: childFeature,
          productApiNames: productApiNames,
          trackingProperties: {
            featureName: childFeature.displayName,
            skuCategoryName,
            featureCategoryName: category.category.categoryName,
            isParentFeature: false
          }
        }, childFeature.featureId))]
      }, feature.featureId))
    })]
  });
};